import React from 'react';
import { langCheck } from "Pub/js/utils.js";
import platform from "Pub/js/platform";
const { NCCheckbox } = platform.base;
import Notice from "Components/Notice";
import { cloneDeep } from "lodash";

function PermissionArea(props) {
    const { isGlobal, setCompanyStyleSettingObj, companyStyleSettingObj } = props;
    const { groupChecked, userChecked } = companyStyleSettingObj;

    // 切换
    const handleSwitch = isTrue => {
        let newCompanyStyleSettingObj = cloneDeep(companyStyleSettingObj);
        if (isGlobal) {
            if (isTrue) {
                if (groupChecked) {
                    newCompanyStyleSettingObj.groupChecked = !groupChecked;
                    newCompanyStyleSettingObj.userChecked = false;
                } else {
                    newCompanyStyleSettingObj.groupChecked = !groupChecked;
                }
            } else {
                if (!groupChecked) {
                    Notice({
                        status: "warning",
                        msg: langCheck('0000PUB-000416'), //多语-全局或集团已统一设置，不支持修改
                    });
                } else {
                    newCompanyStyleSettingObj.userChecked = !userChecked;
                }
            }
        } else {
            if (!groupChecked) {
                Notice({
                    status: "warning",
                    msg: langCheck('0000PUB-000416'), //多语-全局或集团已统一设置，不支持修改
                });
            } else {
                newCompanyStyleSettingObj.userChecked = !userChecked;
            }
        }
        setCompanyStyleSettingObj(newCompanyStyleSettingObj);
    };
    // 权限
    return (<div className='item-block'>
        {/* 允许修改范围 */}
        <div className="item-block-name">
            {langCheck("0000PUB-000662")}
        </div>
        <div>
            {
                isGlobal && <NCCheckbox
                    checked={groupChecked}
                    onChange={() => handleSwitch(true)}
                >
                    {langCheck("0000PUB-000394")}
                </NCCheckbox>
            }
            <NCCheckbox
                checked={userChecked}
                disabled={!groupChecked}
                onChange={() => handleSwitch(false)}
            >
                {langCheck("0000PUB-000395")}
            </NCCheckbox>
        </div>
    </div>);
}

export default PermissionArea;